import React, { Component } from 'react';
import GooglePicker from './GooglePicker';

import ls from 'local-storage';
import { Dropdown, Button, Modal ,SplitButton, Form, InputGroup, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import $ from 'jquery';

const PickerViewMap = {
    Document: "application/vnd.google-apps.document",
    Spreadsheet: "application/vnd.google-apps.spreadsheet",
    Presentation: "application/vnd.google-apps.presentation",
    URL: "URL"
};
const isGoogleFileId = input =>
    /^[a-zA-Z0-9_-]{20,}$/.test(input);
// Google Identity Services token (browser-minted)
let googleTokenClient = null;


const isGoogleFileUrl = input =>
    /^https?:\/\/(docs|drive)\.google\.com\/.+/i.test(input);
export default class TemplateEditor extends Component {
    static displayName = TemplateEditor.name;
    _isMounted = false;
    editor = null;
    iconPickerOptions = null;
    sortableListOptions = null;
   
    constructor(props) {
        super(props);
        this.frmEditRef = React.createRef();
        this.publicAccessCheckChange = this.publicAccessCheckChange.bind(this);
        this.onChangeAllowIndex = this.onChangeAllowIndex.bind(this);

        this.state = {
            addDocFilter: "document",
            allowIndex: true,
            isAddingUrl: false,
            teamOwnerId: ls.get('currentTeam') || props.currentTeam,
            IsPremium: true,
            addEdit: false,
            message: "",
            publicAccess: true,
            templateId: this.props.match.params.id,
            templateName: null,
            templateContent: null,
            documentIdsInList: [],
            newDocs: [],
            googleToken: ls.get('googleToken'),
            googleApiKey: window.GoogleApiKey,
            currentPickerType: null,
            linkInput: "",
            linkName: ""
        };

        this.onChangeTempName = this.onChangeTempName.bind(this);
        this.saveTemplate = this.saveTemplate.bind(this);

        this.iconPickerOptions = {
            searchText: "Buscar...",
            labelHeader: "{0}/{1}"
        };
        this.sortableListOptions = {
            placeholderCss: { 'background-color': "#cccccc" }
        };
    }

    onChangeLinkInput = (e) => {
        this.setState({ linkInput: e.target.value });
    };

    onChangeLinkName = (e) => {
        this.setState({ linkName: e.target.value });
    };

    closeUrlModal = () => {
        this.setState({ isAddingUrl: false, linkInput: "", linkName: "", message: "" });
    };
    hasGoogleAccessIssueRecursive(nodes) {
        if (!Array.isArray(nodes)) return false;

        for (let i = 0; i < nodes.length; i++) {
            const n = nodes[i];

            if (n.googleRelinkRequired === true) {
                return true;
            }

            if (n.children && this.hasGoogleAccessIssueRecursive(n.children)) {
                return true;
            }
        }

        return false;
    }


    getTemplate = async (id) => {
        if (id !== '0') {
            const resp = await fetch('api/template/gettemplate?templateid=' + id, {
                method: 'GET',
                credentials: 'same-origin'
            });
            if (resp.status === 200) {
                try {
                    const jdata = await resp.json();

                    if (jdata.teamId !== this.state.teamOwnerId) {
                        this.props.history.push('/lists');
                    }
                    let docIds = [];
                    //console.log(jdata.content);
                    this.getDocumentIdsRecursive(!!jdata.content ? JSON.parse(jdata.content) : [], docIds);
                    let documentsArray = !!jdata.content ? JSON.parse(jdata.content) : [];
                   

                    const hasGoogleAccessIssues =
                        this.hasGoogleAccessIssueRecursive(documentsArray);

                    this.setState({ hasGoogleAccessIssues });


                    this.setState({                        
                        hasGoogleAccessIssues
                    });
                    this.bindOnRemoveCallbackRecursive(documentsArray);

                    this.setState({
                        allowIndex: jdata.allowIndex,
                        IsPremium: jdata.isPremium,
                        publicAccess: jdata.publicAccess,
                        templateId: jdata.id,
                        templateName: jdata.name,
                        documentIdsInList: docIds,
                        templateContent: documentsArray
                    });
                    this.editor.setData(!!jdata.content ? documentsArray : null);
                    $(".pl-0").show();
                } catch (e) {
                    this.setState({ message: '500: Check console' })
                }
            }
            else if (resp.status === 401) {
                this.setState({ doc: '401: Not Authorized' })
            }
            else {
                this.setState({ message: 'There was a problem, please try again later.' });
            }
        }
        else {
            const resp = await fetch('api/team/getteam?teamid=' + encodeURIComponent(this.state.teamOwnerId), {
                method: 'GET',
                credentials: 'same-origin'
            });
            if (resp.status === 200) {
                try {
                    const jdata = await resp.json();
                    this.setState({ IsPremium: jdata.team.branding.premium })
                }
                catch { this.setState({ IsPremium: false }) }
            }
            else this.setState({ IsPremium: false })
        }
    }
     extractGoogleFileId = (input) => {
        if (isGoogleFileId(input)) return input;

        const match = input.match(/\/d\/([a-zA-Z0-9_-]+)/);
        if (match && match[1]) return match[1];

        return null;
    };
    inferGoogleMimeType = (input) => {
        if (!input) return "application/vnd.google-apps.document";

        const value = input.toLowerCase();

        if (value.includes("/document/d/"))
            return "application/vnd.google-apps.document";

        if (value.includes("/spreadsheets/d/"))
            return "application/vnd.google-apps.spreadsheet";

        if (value.includes("/presentation/d/"))
            return "application/vnd.google-apps.presentation";

        
        return "application/vnd.google-apps.document";
    };
    getGoogleKindFromMimeType = (mimeType) => {
        if (!mimeType) return "Document";

        if (mimeType.includes("spreadsheet")) return "Spreadsheet";
        if (mimeType.includes("presentation")) return "Presentation";

        return "Document";
    };

    buildGoogleFallbackTitle = ({ kind, fileId }) => {
        const shortId = fileId ? fileId.substring(0, 12) : "unknown";
        return `Google ${kind} ${shortId}`;
    };

    onSubmitLink = async (e) => {
        e.preventDefault();

        let { linkInput, linkName } = this.state;
        linkInput = linkInput.trim();

        const googleFileId = this.extractGoogleFileId(linkInput);

  
        if (googleFileId) {
            const mimeType = this.inferGoogleMimeType(linkInput);
            const kind = this.getGoogleKindFromMimeType(mimeType);
            const getfilenameRes = await this.getGoogleFileName(linkInput);
            //console.log("getfilenameRes:"+ getfilenameRes);
            const displayName =
                (linkName && linkName.trim()) || getfilenameRes ||
                this.buildGoogleFallbackTitle({
                    kind,
                    fileId: googleFileId
                });
            

            this.editorAdd([{
                text: displayName,
                href: googleFileId,
                target: mimeType,                 
                title: null,                      
                icon: false,
                googleRelinkRequired: false
            }]);

            this.setState({
                isAddingUrl: false,
                linkInput: "",
                linkName: "",
                message:
                    "This Google file was added by URL. " +
                    "It must be shared with anyone who has the link."
            });

            return;
        }

       
        this.editorAdd([{
            text: linkName || linkInput,
            href: linkInput,
            target: "URL"
        }]);

        this.closeUrlModal();
    };



   


    getDocumentIdsRecursive = (documentsArray, idsArray) => {
        for (var i = 0; i < documentsArray.length; i++) {
            idsArray.push(documentsArray[i].href);
            if (documentsArray[i].children) {
                this.getDocumentIdsRecursive(documentsArray[i].children, idsArray);
            }
        }
    }

    getDocumenChildIdsRecursive = (documentsArray, id, idsArray) => {
        if (documentsArray) {
            for (var i = 0; i < documentsArray.length; i++) {
                if (documentsArray[i].href == id && documentsArray[i].children) {
                    this.getDocumentIdsRecursive(documentsArray[i].children, idsArray)
                }
                else if (documentsArray[i].children) {
                    this.getDocumenChildIdsRecursive(documentsArray[i].children, id, idsArray);
                }
            }
        }
    }

    bindOnRemoveCallbackRecursive = (documentsArray) => {
        for (var i = 0; i < documentsArray.length; i++) {
            documentsArray[i].onRemoveItemCallback = this.onRemoveItemCallback;
            if (documentsArray[i].children) {
                this.bindOnRemoveCallbackRecursive(documentsArray[i].children);
            }
        }
    }

    onRemoveItemCallback = ({ href }) => {
        const docIds = [];
        var _newDocs = this.state.newDocs;
        this.setState({ newDocs: _newDocs.filter(item => item.href !== href) });
        docIds.push(href);

        this.getDocumenChildIdsRecursive(this.state.templateContent, href, docIds);
        var _documentIdsInList = this.state.documentIdsInList.filter(item => !docIds.includes(item));
        const documents = this.state.templateContent;
        var newdocuments = documents.filter(item => item.href !== href);

        this.setState({ documentIdsInList: _documentIdsInList, templateContent: newdocuments });
    }

    updateDocumentName = ({ href, text }) => {
        const documents = this.state.templateContent;
        if (text && text.trim().length) {
            this.updateDocumentNameInDocTreeRecursive({ documentsArray: documents, href, text });
        }
        this.setState({ templateContent: documents })
        this.editor.setData(documents);
        $(".pl-0").show();
    }

    updateDocumentNameInDocTreeRecursive({ documentsArray, href, text }) {
        if (documentsArray) {
            for (var i = 0; i < documentsArray.length; i++) {
                if (documentsArray[i].href == href) {
                    documentsArray[i].text = text
                }
                else if (documentsArray[i].children) {
                    this.updateDocumentNameInDocTreeRecursive({ documentsArray: documentsArray[i].children, href, text })
                }
            }
        }
    }

    editorAdd = (data) => {
        this.bindOnRemoveCallbackRecursive(data);
        var i;
        var _newDocs = this.state.newDocs;
        for (i = 0; i < data.length; i++) {
            this.editor.addData(data[i]);
            _newDocs.push(data[i]);
        }
        let _documentIdsInList = this.state.documentIdsInList;
        _documentIdsInList.push(...(data.map(file => file.href)));
        this.setState({ documentIdsInList: _documentIdsInList, newDocs: _newDocs });
    }
    setPublicPermission = async (fileId, accessToken) => {
        //console.log("[Drive] Setting public permission:", {
        //    fileId: fileId || null,
        //    hasToken: !!accessToken
        //});

        const res = await fetch(
            `https://www.googleapis.com/drive/v3/files/${fileId}/permissions?supportsAllDrives=true`,
            {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    type: "anyone",
                    role: "writer" 
                })
            }
        );

        const body = await res.text();

        //console.log("[Drive] Permission API response:", {
        //    fileId: fileId,
        //    status: res.status,
        //    ok: res.ok,
        //    body: body
        //});

        if (!res.ok) {
            if (res.status === 401 || res.status === 403) {
                //console.warn("[Drive] Token invalid, clearing cache");

                // Clear token everywhere
                localStorage.removeItem("googleAccessToken");
                localStorage.removeItem("googleAccessToken_exp");
                this.props.setGoogleAccessToken(null);
                this.props.setGoogleAuthInvalid(true);
            }

            return { success: false, status: res.status, body };
        }


        return { success: true };

    };
    //getGoogleFileName = async (linkInput) => {
    //    console.log("[Drive] Getting Name:", {
    //        linkinput: linkInput || null
    //    });
    //    // Browser or Node (Node will fetch HTML, browser will hit CORS)
    //    const res = await fetch(
    //        linkInput
    //    );

    //    const html = await res.text();
    //    console.log(html); // You’ll see a generic app shell, not the doc name


    //};
    getGoogleFileName = async (linkInput) => {
        
        var fileid = this.extractGoogleFileId(linkInput)
        //console.log("[Drive] Getting Name:", {
        //    fileId: fileid || null
        //});
        const resp = await fetch('api/doc/getname?fileid='+fileid, {
            method: 'GET',
            credentials: 'same-origin',          
            //headers: { 'Content-Type': 'application/json' }
        });

       

        if (!resp.ok) {
            

            return  "";
        }

        const body = await resp.json();

        //console.log("[Drive] Get Name API response:", {
        //    fileId: fileid,
        //    status: resp.status,
        //    ok: resp.ok,
        //    body: body
        //});
        return body.name ;

    };
    onFilesPicked = async (docs) => {
        this.clearPicker("onFilesPicked");


        //console.log("[Picker] Raw docs:", docs);

        const newDocs = docs.filter(
            d => !this.state.documentIdsInList.includes(d.id)
        );

        //console.log("[Picker] New docs after de-dupe:", newDocs);

        if (newDocs.length === 0) {
            //console.warn("[Picker] No new documents selected");
            this.setState({ message: "These documents are already in your collection." });
            return;
        }

        try {
            const accessToken = this.props.googleAccessToken;
            //console.log("[Picker] Using access token present:", !!accessToken);

            const nodes = [];

            for (const d of newDocs) {

                //console.log("[Picker] Processing file:", {
                //    id: d.id || null,
                //    name: d.name || null,
                //    mimeType: d.mimeType || null
                //});

                let permissionResult = null;

                if (accessToken) {
                    permissionResult = await this.setPublicPermission(d.id, accessToken);
                }

                const node = {
                    text: d.name || "(untitled)",
                    href: d.id || null,
                    target: d.mimeType || null,
                    title: null,
                    icon: false,
                    googleRelinkRequired: permissionResult && permissionResult.success === false
                };

                if (permissionResult && permissionResult.success === false) {
                    //console.warn("[Picker] Auto-share failed, marking for manual fix:", d.id);
                } else {
                    //console.log("[Picker] Permissions updated successfully:", d.id);
                }

                nodes.push(node);
            }


            this.setState({ preselectFileId: null });

            //console.log("[Picker] Adding nodes to editor:", nodes);
            this.editorAdd(nodes);

        } catch (e) {
            //console.error("[Picker] Unexpected error during file processing:", e);
            this.setState({
                message: `
            Some files could not be automatically shared.
            <br/><br/>
            Please open the file in Google Docs and set:
            <b>Share → Anyone with the link → Editor</b>,
            then return and try again.
        `
            });
        }

    };








    addTemplate = () => {
        this.setState({ addEdit: !this.state.addEdit });
    }

    onEditDocNameFormSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const formvalues = $(e.target).serializeArray();
        let object = {};
        formvalues.forEach(function (obj, index) {
            object[obj.name] = obj.value;
        });

        try {
            $("#frmEdit").appendTo($("#frmEditWrapper"));
        } catch (e) { }
        this.editor.resetForm();
        this.updateDocumentName(object);
    }

    onEditDocNameInputBlur = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const formvalues = $(e.target).parents("#frmEdit").eq(0).serializeArray();
        let object = {};
        formvalues.forEach(function (obj, index) {
            object[obj.name] = obj.value;
        });

        try {
            $("#frmEdit").appendTo($("#frmEditWrapper"));
        } catch (e) { }
        this.editor.resetForm();
        this.updateDocumentName(object);
    }

    resetDocEditForm = (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            $("#frmEdit").appendTo($("#frmEditWrapper"));
        } catch (e) { }
        this.editor.resetForm();
    }
    validateGoogleToken = async (token) => {
        try {
            const resp = await fetch(
                "https://www.googleapis.com/drive/v3/about?fields=user",
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            return resp.ok; // true = valid, false = expired/revoked
        } catch (err) {
            //console.error("[GIS] Token validation error", err);
            return false;
        }
    };

    componentDidMount() {
        //console.warn("[TemplateEditor] MOUNTED");
        this._isMounted = true;

        this.editor = new window.MenuEditor('myEditor', {
            listOptions: this.sortableListOptions
        });
        //console.log("window.GoogleClientId:" + window.GoogleClientId);
        this.editor.setForm($('#frmEdit'));
        this.editor.parentEditor = this;
        this.editor.onChange = this.onChangeData;
        if (window.google && window.google.accounts && window.google.accounts.oauth2) {
            googleTokenClient = window.google.accounts.oauth2.initTokenClient({
                client_id: window.GoogleClientId,
                scope: "https://www.googleapis.com/auth/drive.file",
                callback: (resp) => {
                    const token = resp.access_token;
                    const expiresIn = resp.expires_in || 3600; // seconds
                    const exp = Date.now() + (expiresIn * 1000);

                    //console.log("[GIS] Token received, expires at:", new Date(exp).toISOString());

                    // Store in parent state
                    this.props.setGoogleAccessToken(token);

                    // Cache locally for reloads
                    localStorage.setItem("googleAccessToken", token);
                    localStorage.setItem("googleAccessToken_exp", exp.toString());
                }
            });
            //if (localStorage.getItem("google_authed") === "true") {
            //    console.log("[GIS] Attempting silent token request on load...");
            //    googleTokenClient.requestAccessToken({
            //        prompt: "",   // suppress account picker if possible
            //        callback: (resp) => {
            //            this.props.setGoogleAccessToken(resp.access_token);
            //            console.log("[GIS] Silent token received:", !!resp.access_token);
            //        }
            //    });
            //}
        } else {
            //console.warn("[GIS] Google Identity Services not loaded");
        }

        const token = localStorage.getItem("googleAccessToken");
        const exp = localStorage.getItem("googleAccessToken_exp");

        if (token && exp && Date.now() < parseInt(exp, 10)) {
            //console.log("[GIS] Found cached token, validating...");

            this.validateGoogleToken(token).then((isValid) => {
                if (isValid) {
                    //console.log("[GIS] Cached token is valid");
                    this.props.setGoogleAccessToken(token);
                } else {
                    //console.warn("[GIS] Cached token invalid, clearing");
                    localStorage.removeItem("googleAccessToken");
                    localStorage.removeItem("googleAccessToken_exp");
                    this.props.setGoogleAccessToken(null);
                }
            });
        } else {
            //console.log("[GIS] No valid cached token");
            localStorage.removeItem("googleAccessToken");
            localStorage.removeItem("googleAccessToken_exp");
        }
        if (this.state.templateId) {
            (async () => { this.getTemplate(this.state.templateId) })();
        }
    }

    async componentDidUpdate(prevProps) {
        if (this.props.currentTeam !== prevProps.currentTeam) {
            await this.setState({ msg: "You switched to a new team. Taking you to their Lists..." });
            setTimeout(null, 1);
            this.props.history.push('/lists');
        }
    }

    componentWillUnmount() {
        //console.warn("[TemplateEditor] UNMOUNTED");
        this._isMounted = false;
    }

    handleScriptCreate() { this.setState({ scriptLoaded: false }) }
    handleScriptError() { this.setState({ scriptError: true }) }
    handleScriptLoad() { this.setState({ scriptLoaded: true }) }

    onChangeData(e) {
        let jdata = JSON.parse(e.getString());
        let docIds = [];
        e.parentEditor.getDocumentIdsRecursive(jdata, docIds);
        let documentsArray = jdata;
        e.parentEditor.bindOnRemoveCallbackRecursive(documentsArray);
        e.parentEditor.setState({ documentIdsInList: docIds, templateContent: documentsArray })
    }

    onChangeAllowIndex(e) {
        this.setState({ allowIndex: e.target.checked });
    }

    onChangeTempName(e) {
        this.setState({ templateName: e.target.value });
    }

    onAddDocSelect = (eventKey, e) => {
        /*e.preventDefault();*/
        //console.log("onAddDocSelect fired:", eventKey);
        if (e && e.preventDefault) e.preventDefault();
        const pickerType = PickerViewMap[eventKey];
        //console.log("TemplateEditor googleAuthInvalid:", this.props.googleAuthInvalid);
        //if (this.props.googleAuthInvalid === true) {
        //    this.setState({
        //        message: "Google access needs to be reconnected before adding files.",
        //        showReconnect: true
        //    });
        //    return;
        //}
        if (pickerType === "URL") {
            // existing URL handling
            this.setState({ isAddingUrl: true, message:"" });
            return;
        }

        // Google Picker flow
        this.openPicker(pickerType);
    };


    openPicker = (mimeType) => {
        this.setState({ currentPickerType: mimeType,message: "Preparing Google Picker..." });
        if (this.props.googleAccessToken) {
            //console.log("[GIS] Reusing existing token");
            return;
        }
        if (!googleTokenClient) {
            //console.warn("[GIS] Token client not initialized");
            this.setState({ message: "Google authentication not available." });
            return;
        }
        //console.log("[GIS] before auth for:", this.state.currentPickerType);
        //console.log("[GIS] Requesting browser access token...");

        googleTokenClient.requestAccessToken({
            prompt: "",
            callback: (resp) => {
                this.props.setGoogleAccessToken(resp.access_token);
               // localStorage.setItem("google_authed", "true");               
                //console.log("[GIS] Re-opening picker after auth for:", mimeType);
                this.setState({ currentPickerType: mimeType });               
             
            }
        });
    };



    clearPicker = (source) => {
        //console.warn("[Picker] CLEAR triggered from:", source);
        this.setState({ currentPickerType: null, message: "" });
    };




    saveTemplate = async (e, view) => {
        e.preventDefault();

        if (this.state.templateName === null || this.state.templateName === "") {
            this.setState({ message: "You must enter a name for the collection." });
            return;
        }
        var viewUrl = "";
        await this.setState({ message: "Working..." });
        var data = {
            AllowIndex: this.state.allowIndex, Id: this.state.templateId, Name: this.state.templateName,
            TeamId: this.state.teamOwnerId, TemplateNodes: this.editor.getString(),
            NewDocs: JSON.stringify(this.state.newDocs),
            PublicAccess: this.state.publicAccess
        }

        await this.setState({ message: "Saving..." });
        const resp = await fetch('api/template/savetemplate', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
        });
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();
                this.setState({ message: jdata.statusText });
                this.setState({ templateId: jdata.templateRetId, newDocs: [] });
                viewUrl = jdata.viewUrl;
            } catch (e) {
                this.setState({ message: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ doc: '401: Not Authorized' })
        }
        else if (resp.status === 400) {
            const jdata = await resp.json();
            this.setState({ message: jdata.statusText });
        }
        else {
            this.setState({ message: 'There was a problem, please try again later.' });
        }
        if (view) {
            window.open(viewUrl, '_blank');
        }
    }

    publicAccessCheckChange = async (e) => {
        await this.setState({ publicAccess: e.target.checked });
    }

    render() {
        //console.log("[TemplateEditor] googleAccessToken from props:", this.props.googleAccessToken);

        const isPremium = this.state.IsPremium;
        const premMsg = !isPremium ? (
            <div className="row ">
                <div className="col  mb20 ml-3 alert alert-danger">
                    Only publicly viewable content is allowed for unpaid Teams
                </div>
            </div>
        ) : "";
        //console.log("[Render] GoogleApiKey:", window.GoogleApiKey);
        //console.log("[Render] currentPickerType:", this.state.currentPickerType);

        return (
            <div>
                <h2>{(this.state.templateId !== 0) ? ("Edit Collection") : ("Add Collection")}</h2>

                <div id="frmEditWrapper" className="d-none">
                    <Form className="pt-2" id="frmEdit" onSubmit={(e) => this.onEditDocNameFormSubmit(e)} ref={this.frmEditRef}>
                        <InputGroup>
                            <FormControl className="item-menu" size="sm" type="text" name="text" placeholder="Enter document name" aria-label="Enter document name" onBlurCapture={(e) => this.onEditDocNameInputBlur(e)} />
                            <Form.Control size="sm" type="hidden" className="item-menu" name="href" />
                        </InputGroup>
                        <Form.Text className="text-muted form-text mt-0 mb-2 ml-1 form-text">
                            Edit document name. Changes will only apply if you save the list using the save button at the bottom
                        </Form.Text>
                    </Form>
                </div>
                {this.state.currentPickerType &&
                    this.state.currentPickerType !== "URL" &&
                    this.props.googleAccessToken && (   
                        <GooglePicker
                            token={this.props.googleAccessToken}
                            apiKey={window.GoogleApiKey}
                            appId={window.GoogleAppId}
                            view={this.state.currentPickerType}                          
                            onPicked={this.onFilesPicked}
                        onCancel={() => {
                           
                            this.clearPicker("onCancel");
                        }}

                        />
                    )}


                <div className="" id="tempeditor">
                    {this.state.hasGoogleAccessIssues && (
                        <div className="google-access-banner">
                            <strong>
                                <span className="ga-indicator"></span>
                                Google access update
                            </strong>
                            <div>
                                We updated Google permissions. Some files need to be added again so GStitch can access them.
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col mb20">
                            <input type="text" name="name" placeholder="Untitled" value={this.state.templateName} className="form-control-lg form-control" onChange={this.onChangeTempName} />
                        </div>
                    </div>
                    {premMsg}
                    <div className="row ">
                        <div className="col  mb20 ml-3 custom-control custom-checkbox">
                            <input type="checkbox" id="access" className="custom-control-input ml-0" disabled={!isPremium} checked={this.state.publicAccess} onChange={(e) => this.publicAccessCheckChange(e)} />
                            <label className="custom-control-label" htmlFor="access">Public Access (vs. Team Only) </label>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col  mb20 ml-3 custom-control custom-checkbox">
                            <input type="checkbox" id="index" className="custom-control-input ml-0" disabled={!isPremium} checked={this.state.allowIndex} onChange={(e) => this.onChangeAllowIndex(e)} />
                            <label className="custom-control-label" htmlFor="index">Allow Search Engine Indexing On This Collection (if public)</label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col mb-3">
                            <ul id="myEditor" className="sortableLists list-group"></ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-3">
                            <div className="btn-group">
                                <SplitButton
                                    variant="secondary"
                                    title="Add Document"
                                    onClick={(e) => this.onAddDocSelect("Document", e)}
                                    onSelect={(eventKey, e) => this.onAddDocSelect(eventKey, e)}
                                    id="add-doc-split"
                                >
                                    <Dropdown.Item eventKey="Presentation">Add Presentation</Dropdown.Item>
                                    <Dropdown.Item eventKey="Spreadsheet">Add Spreadsheet</Dropdown.Item>
                                    <Dropdown.Item eventKey="URL">Add URL</Dropdown.Item>
                                </SplitButton>


                                <button onClick={(e) => this.saveTemplate(e, false)} className="btn btn-primary">Save & Continue</button>
                                <button onClick={(e) => this.saveTemplate(e, true)} className="btn btn-primary">Save & View</button>
                            </div>
                            <Link to="/lists" className="btn btn-light " style={{ float: 'right' }}>Back</Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-3">
                            <div className="alert alert-info mt20" dangerouslySetInnerHTML={{ __html: this.state.message }}></div>
                        </div>
                        <div className="col mb-3">
                            {this.state.showReconnect && (
                                <div className="alert alert-info mt20">
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();

                                            this.props.history.push('/login', {
                                                googleReconnect: true, prevpath: this.props.location.pathname
                                            });
                                        }}
                                    >
                                        Reconnect Google
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    <div id="viewDoc" className="modal" tabIndex="-1" role="dialog">
                        <div className="modal-dialog  modal-lg modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body"></div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {this.state.isAddingUrl && (
                    <Modal show onHide={this.closeUrlModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add by Link or ID</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={this.onSubmitLink}>
                                <Form.Group>
                                    <Form.Label>Name (optional)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={this.state.linkName}
                                        onChange={this.onChangeLinkName}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>Link or Google File ID</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={this.state.linkInput}
                                        onChange={this.onChangeLinkInput}
                                        required
                                    />
                                    <Form.Text muted>
                                        If adding a Google drive item, ensure the permissions allow anyone with the ID/URL to view it. Non Google drive URLs will be embedded in an iFrame.
                                    </Form.Text>
                                </Form.Group>

                                <Button type="submit">Add</Button>
                            </Form>
                        </Modal.Body>
                    </Modal>
                )}


            </div>
        );
    }
}
